import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import NetworkZoneForm from "./NetworkZoneForm";
import NetworkZoneConfirmationDialog from './NetworkZoneConfirmationDialog';
import { CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import * as actions from '../store/networkZoneActions';
import History from "../../../History";
import { hasPermission } from "../../sc-utilities";
import { CancelToken } from 'axios';

const NetworkZoneCreate = props => {
    const { activeCustomerID, translations, listPermissions, createNetworkZone, whoIs, permissions: userPermissions } = props;
    const [createData, setCreateData] = useState({ permissions: [], loadingData: true, UserIP: null });
    const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
    const [dataToSend, setDataToSend] = useState(null);
    const [confirming, setConfirming] = useState(false);

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            let permissions = await listPermissions({ ActiveCustomerID: activeCustomerID }, { CancelToken: requestToken.token });
            let UserIP = await whoIs();
            setCreateData({ permissions: permissions, loadingData: false, UserIP: UserIP });
        }
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const extractPermissions = selectedPermission => {
        return selectedPermission.map(permission => permission.value);
    };

    const handleSubmit = async data => {
        let formData = { ...data };
        formData['CustomerID'] = activeCustomerID;
        formData['Permissions'] = extractPermissions(data.Permissions);
        let result = await createNetworkZone({ ...formData, ActiveCustomerID: activeCustomerID });
        if (result) {
            if (result.ConfirmationNeeded && result.ConfirmationCode) {
                setConfirmationDialogOpen(true);
                setDataToSend({ ...formData, ActiveCustomerID: activeCustomerID, ConfirmationCode: result.ConfirmationCode });
                return;
            }
            History.goBack();
        }
    };

    const handleConfirmTrue = async () => {
        setConfirming(true);
        let result = await createNetworkZone(dataToSend);
        setDataToSend(null);
        setConfirming(false);
        setConfirmationDialogOpen(false);
        if (result) {
            History.goBack();
        }
    };

    const handleConfirmFalse = () => {
        setConfirming(true);
        setDataToSend(null);
        setConfirming(false);
        setConfirmationDialogOpen(false);
    };

    let initialValues = {
        Name: "",
        Subnet: !createData.UserIP || createData.UserIP === '::1' ? '' : createData.UserIP,
        Policy: "allow",
        Priority: "normal",
        Permissions: [],
        SpecifyPermissions: false,
        DefaultLanguage: 'en',
        DefaultKeyboardLayout: 'en'
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Subnet: Yup.string().required("Required"),
            Policy: Yup.string().required("Required"),
            Priority: Yup.string().required("Required"),
            Permissions: Yup.array().when('SpecifyPermissions', {
                is: val => val === true,
                then: Yup.array().min(1).required("Required")
            }),
            SpecifyPermissions: Yup.boolean().required("Required"),
            DefaultLanguage: Yup.string().required("Required"),
            DefaultKeyboardLayout: Yup.string().required("Required")
        },
        FormTitle: translations["create_network_zone"] || "Create network zone",
        ButtonSubmit: hasPermission(userPermissions, 'network_zone_create') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return (
        !createData.loadingData ?
            <>
                <NetworkZoneConfirmationDialog
                    translations={translations}
                    confirmationDialogOpen={confirmationDialogOpen}
                    handleConfirmTrue={handleConfirmTrue}
                    handleConfirmFalse={handleConfirmFalse}
                    confirming={confirming}
                    subnet={dataToSend?.Subnet ?? ''}
                />
                <NetworkZoneForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    translations={translations}
                    permissions={createData.permissions}
                    currentIP={createData.UserIP}
                />
            </>

            : <CircularProgress />

    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createNetworkZone: data => dispatch(actions.createNetworkZone(data)),
        listPermissions: activeCustomerID => dispatch(actions.listPermissions(activeCustomerID)),
        whoIs: () => dispatch(actions.whoIs())
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NetworkZoneCreate);
